<div class="searchbar rounded mb-2">
  <input
    type="search"
    placeholder="Rechercher ..."
    class="form-control"
    aria-label="Search"
    [(ngModel)]="search"
    (ngModelChange)="searchChanged()"
    (keyup.enter)="launch()" />
</div>
